export class LoggingService{
  logBtnClick(message: string){
    console.log("Button Click + "+message);
  }
}
